module.exports = __webpack_public_path__ + "static/media/d1-wifi.f79be076.png";